import { render, staticRenderFns } from "./BannerEntitySelector.vue?vue&type=template&id=19ec0a30&"
import script from "./BannerEntitySelector.vue?vue&type=script&lang=js&"
export * from "./BannerEntitySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports